/* eslint-disable @angular-eslint/no-host-metadata-property */
import { CdkTree } from '@angular/cdk/tree';
import { ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { NTreeNodeOutletDirective } from './outlet.directive';

/**
 * Wrapper for the CdkTable.
 */
@Component({
  selector: 'n-tree',
  exportAs: 'NTree',
  template: `<ng-container nTreeNodeOutlet></ng-container>`,
  host: {
    class: 'n-tree',
    role: 'tree',
  },
  encapsulation: ViewEncapsulation.None,
  // See note on CdkTree for explanation on why this uses the default change detection strategy.
  // tslint:disable-next-line:validate-decorators
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [{ provide: CdkTree, useExisting: NTreeComponent }],
})
export class NTreeComponent<T, K = T> extends CdkTree<T, K> {
  // Outlets within the tree's template where the dataNodes will be inserted.
  @ViewChild(NTreeNodeOutletDirective, { static: true }) override _nodeOutlet: NTreeNodeOutletDirective;
}
